export const dadosAcao = [
  { cod: 1, nome: 'Não altera o pH' },
  { cod: 2, nome: 'Reduz o pH' },
  { cod: 3, nome: 'Aumenta o pH' },
  { cod: 4, nome: 'Ajusta o pH' },
]

export function filtrarPropriedades(
  setCaldasSelecionadas,
  setGotaSelecionadas,
  dados
) {
  const editNaCalda = dados
    ?.filter((item) => item.tipo_propriedade_adjuvante === 1)
    ?.map((item) => {
      return {
        descr: item?.propriedade_adjuvante_nome,
        id: item?.cod_propriedade_adjuvante,
        key: item?.cod_propriedade_adjuvante,
      }
    })
  const editNaGota = dados
    ?.filter((item) => item.tipo_propriedade_adjuvante === 2)
    ?.map((item) => {
      return {
        descr: item?.propriedade_adjuvante_nome,
        id: item?.cod_propriedade_adjuvante,
        key: item?.cod_propriedade_adjuvante,
      }
    })
  setCaldasSelecionadas(editNaCalda)
  setGotaSelecionadas(editNaGota)
}

export function filtrarPropriedadesEditar(
  setCaldasSelecionadasEditar,
  setGotaSelecionadasEditar,
  dados
) {
  const editNaCalda = dados
    ?.filter((item) => item.tipo_propriedade_adjuvante === 1)
    ?.map((item) => {
      return item?.cod_propriedade_adjuvante
    })
  const editNaGota = dados
    ?.filter((item) => item.tipo_propriedade_adjuvante === 2)
    ?.map((item) => {
      return item?.cod_propriedade_adjuvante
    })
  setCaldasSelecionadasEditar(editNaCalda)
  setGotaSelecionadasEditar(editNaGota)
}

export function verificarPropriedadesRemover(
  caldaEditar,
  gotaEditar,
  caldaSelecionadas,
  gotaSelecionadas,
) {
  const calda = caldaSelecionadas?.map((item) => item.id)
  const trajeto_gota = gotaSelecionadas?.map((item) => item.id)

  const caldaRemover = caldaEditar.filter((id) => !calda.includes(id))
  const gotaRemover = gotaEditar.filter((id) => !trajeto_gota.includes(id))

  return {
    calda: caldaRemover,
    planta: gotaRemover,
  }
}